import React, { useMemo } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { buildSheetWorkshopQrValue } from '../../../services/lotScanResolve';

/**
 * En-tête imprimable : QR en haut à droite + infos patient / cas regroupées.
 * Le QR encode l’UUID / n° de cas pour ouvrir le lot actif depuis l’atelier.
 */
const PatientInfoSection = ({ patientData, totalIPR, contactsWithIpr = 0 }) => {
  const qrValue = useMemo(
    () =>
      buildSheetWorkshopQrValue({
        caseId: patientData?.caseId || null,
        caseNumber: patientData?.caseNumber || null,
      }),
    [patientData]
  );

  const fields = [
    { label: 'Patient', value: patientData?.patientName },
    { label: 'N° Patient', value: patientData?.patientId },
    { label: 'Date de naissance', value: patientData?.dateOfBirth },
    { label: 'N° Cas', value: patientData?.caseNumber },
    { label: 'Praticien', value: patientData?.dentistName },
    { label: 'Clinique', value: patientData?.clinicName },
    { label: 'Traitement', value: patientData?.treatmentType },
    { label: 'Date fiche', value: patientData?.createdDate },
    { label: 'Total IPR', value: `${totalIPR} mm` },
    { label: 'Contacts IPR', value: String(contactsWithIpr) },
    { label: 'Référence', value: `IPR-${patientData?.caseNumber || '—'}` },
  ];

  return (
    <div className="border-b border-gray-200/80 p-4 md:p-5">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between mb-4">
        <div className="min-w-0">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 leading-tight">
            Fiche de Stripping (IPR)
          </h2>
          <p className="text-sm text-gray-600 mt-0.5">
            Réduction inter-proximale — Instructions de traitement
          </p>
          <p className="text-xs text-gray-500 mt-0.5">ClearMotion Orthodontie</p>
        </div>

        <div className="flex shrink-0 flex-col items-center gap-1.5 self-center sm:self-start">
          <div className="rounded-lg border border-gray-200 bg-white p-2">
            {qrValue ? (
              <QRCodeSVG value={qrValue} size={112} level="M" includeMargin={false} />
            ) : (
              <div className="w-[112px] h-[112px] bg-gray-100 rounded flex items-center justify-center text-[10px] text-gray-400 text-center px-2">
                Cas indisponible
              </div>
            )}
          </div>
          <span className="text-[10px] font-medium text-gray-500 tracking-wide uppercase">
            Traçabilité
          </span>
        </div>
      </div>

      <div className="rounded-xl border border-gray-200 bg-white/90 overflow-hidden">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 divide-x divide-y divide-gray-100">
          {fields.map((field) => (
            <div key={field.label} className="px-3 py-2.5 min-w-0">
              <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500 mb-0.5">
                {field.label}
              </div>
              <div className="text-sm font-semibold text-gray-900 break-all whitespace-normal leading-snug">
                {field.value || '—'}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PatientInfoSection;
